<template>
  <LeaderTeamRequests
    isEditable
    @update="
      () => {
        emit('update');
      }
    "
  />
</template>

<script setup>
  import LeaderTeamRequests from '@/views/leader/team/components/LeaderTeamRequests.vue';

  const emit = defineEmits(['update']);
</script>

<style lang="scss" scoped></style>
